import request from '@/utils/request'

/**
 * 获取联系我们弹出菜单中由运营后台配置的启用项。
 */
export function getContactMenuList() {
  return request({
    url: '/api/client/contact-menu/list',
    method: 'get'
  })
}
